module.exports = __webpack_public_path__ + "static/media/adidas.88c067dc.png";